import { stateNames } from '@sly/core/constants/geo';
import round from 'lodash/round';

const povertyDataByState = {
  MS: 0.19072280774313535,
  LA: 0.18002496660859868,
  NM: 0.17846450438027864,
  WV: 0.1690109756454639,
  KY: 0.15757904743801113,
  AR: 0.1546572322213586,
  AL: 0.1496068475594888,
  OK: 0.145588254674019,
  DC: 0.14442282414501648,
  SC: 0.13794581932851696,
  TN: 0.1363244749982416,
  AZ: 0.13422978133834623,
  GA: 0.13263883557279094,
  MI: 0.13193864932132188,
  NC: 0.13182683852699364,
  TX: 0.13129662410756499,
  OH: 0.13015390210576738,
  NY: 0.1262237633308839,
  MO: 0.1245814872894946,
  FL: 0.12401752634737183,
  IN: 0.1218940184672967,
  CA: 0.12066164101466645,
  SD: 0.1198385317707565,
  MT: 0.11906157092681734,
  NV: 0.11832451286985807,
  IL: 0.11623812218749141,
  OR: 0.11620674862529277,
  PA: 0.1130721046902434,
  KS: 0.1092171316650176,
  ID: 0.10709157007167694,
  RI: 0.10603409007023627,
  DE: 0.10578437837513795,
  ME: 0.10519329223734644,
  WY: 0.10503480442204688,
  IA: 0.10486545529216607,
  WI: 0.10426031236772208,
  AK: 0.10045263048414307,
  VT: 0.0998027084017838,
  NE: 0.09681067225027122,
  ND: 0.09554475466189258,
  WA: 0.09388633268841827,
  CT: 0.0938061385164261,
  VA: 0.09372571000477978,
  MA: 0.09107875500863881,
  CO: 0.0907496494121296,
  NJ: 0.08928723547179503,
  MN: 0.08772297123950945,
  HI: 0.08624765966509454,
  MD: 0.08439593066410514,
  UT: 0.08275858040529391,
  NH: 0.0697913166700935
};

export function getPercentage(proportion: number) {
  return proportion * 100;
}

export type StateAbbr = keyof typeof stateNames;

export function comparePovertyRate(
  state: keyof typeof stateNames,
  rate: number
) {
  const stateRate =
    povertyDataByState[state as keyof typeof povertyDataByState];

  if (stateRate) {
    const statePercentage = getPercentage(stateRate);
    const diff = getPercentage(rate) - statePercentage;
    const roundedDiff = round(diff);
    const higherOrLower = diff > 0 ? 'higher' : 'lower';

    if (!roundedDiff)
      return `The poverty rate is similar for this region compared to the ${
        stateNames[state]
      } state average, which is ${round(statePercentage)}%`;

    return `The poverty rate is ${Math.abs(
      roundedDiff
    )}% ${higherOrLower} for this region compared to the ${
      stateNames[state]
    } state average, which is ${round(statePercentage)}%`;
  }
  return null;
}
